import * as Sentry from '@sentry/core';
import { STATIC_SESSIONS } from './content/session/static';
import { STATIC_SESSIONS as STATIC_SESSIONS_OTX207 } from './content/session/staticOTX207';
import { STATIC_SESSIONS as STATIC_SESSIONS_OTX601 } from './content/session/staticOTX601';
import { SUPPORT_CONTENT } from './content/session/support';
import { ProductVariant } from './types/graphql.generated';
// getStaticSession is a bit of a misnomer now. It used to refer to non-dynamic content written in
// markdown but since we've started using this style of content for the AVIVA_SUPPORT,productStatic=false
// users
export function getStaticSession(param) {
    var contentType = param.contentType, productSlug = param.productSlug, roleType = param.roleType, productStatic = param.productStatic;
    // console.log({ productSlug, roleType });
    if (productStatic) {
        var session = STATIC_SESSIONS[contentType];
        if (productSlug === ProductVariant.AVIVA_ADOLESCENT) {
            session = STATIC_SESSIONS_OTX207[contentType];
        } else if (productSlug === 'PTSD') {
            session = STATIC_SESSIONS_OTX601[contentType];
        }
        return typeof session === 'function' ? session(roleType) : session;
    } else if (productSlug === ProductVariant.AVIVA_ADOLESCENT && roleType === 'SUPPORTER') {
        return SUPPORT_CONTENT[contentType];
    }
    Sentry.captureMessage('Invalid call to getStaticSession', {
        extra: {
            contentType: contentType,
            productSlug: productSlug,
            productStatic: productStatic
        }
    });
    return [];
}
